import "react-app-polyfill/stable"
import "core-js"
import React from "react"
import ReactDOM from "react-dom"
import { createTheme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles"

import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react"
import store from "./store"

const persistor = persistStore(store);

let theme = createTheme({
    typography: {
        fontFamily: ["Arial", "sans-serif"].join(","),
    },
    palette: {
        primary: {
            main: "#ff0000", 
        },
        secondary: {
            main: "#ffcc80",
        },
        white: {
            main: "#ffffff",
            overrides: {
                MuiButton: {
                    label: {
                        color: "#ff0000",
                    },
                },
            },
        },
    },
})

theme = responsiveFontSizes(theme);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </PersistGate>
    </Provider>,
    document.getElementById("root"),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
